define('meetings/action-center/action-center',['require','exports','module','durandal/app','knockout','i18next','lodash','react-action-center','notifications/trial-ending-marvel-notification/trial-ending-marvel-notification','invite-component/invite-component-container','scheduler/scheduler-container','popover-binder','bowser','web-urls','api-access','api-access','api-access','../../invite-popover/invite-popover','mixpanel-helper','plugins/router','meeting-modal/gotomeet/personalize-meeting','video-player-modal/video-player-modal','meetings/lib/start-meeting/start-meeting'],function (require, exports, module) {
    var app = require('durandal/app');
    var ko = require('knockout');
    var i18n = require('i18next');
    var _ = require('lodash');
    var ActionCenter = require('react-action-center');
    var MarvelMessage = require('notifications/trial-ending-marvel-notification/trial-ending-marvel-notification');
    var Invite = require('invite-component/invite-component-container');
    var Scheduler = require('scheduler/scheduler-container');
    var popover = require('popover-binder');
    var bowser = require('bowser');
    var webUrls = require('web-urls');
    var g2mmApi = require('api-access').gotomeet;
    var meetingsApi = require('api-access').meetings;
    var userApi = require('api-access').user;
    var invitePopover = require('../../invite-popover/invite-popover');
    var mixpanelHelper = require('mixpanel-helper');
    var router = require('plugins/router');
    var personalizeMeeting = require('meeting-modal/gotomeet/personalize-meeting');
    var videoPlayerModal = require('video-player-modal/video-player-modal');
    var startMeeting = require('meetings/lib/start-meeting/start-meeting').startMeeting;

    function actionCenter() {
        var self = this;
        self.gotomeetMeeting = ko.observable(false);
        self.gotomeetProfile = ko.observable(false);
        self.meetingInSession = ko.observable(false);
        self.isModalOpen = ko.observable(false);
        self.gotomeetName = ko.observable(false);
        self.disableG2MM = ko.observable(false);
        self.router = router;

        self.g2mmRoom = ko.computed(function () {
            if (self.gotomeetProfile()) {
                return webUrls.get('gotoMeetMeUrl') + '/' + self.gotomeetProfile().profileId;
            }
            return '';
        });

        self.avatarUrl = ko.computed(function () {
            if (self.gotomeetProfile()) {
                return self.gotomeetProfile().avatarUrl;
            }
            return '';
        });

        self.howToSchedule = function () {
            mixpanelHelper.track('HowToSchedule Clicked');
            videoPlayerModal.show();
        };

        self.reactOptions = ko.computed(function () {
            return {
                component: ActionCenter.default,
                props: {
                    avatarUrl: self.avatarUrl(),
                    g2mmRoom: self.g2mmRoom(),
                    invitePeople: self.invitePeople,
                    language: i18n.lng(),
                    startMeeting: self.startMeeting,
                    endMeeting: self.endMeeting,
                    isMeetingInSession: self.meetingInSession(),
                    editRoom: self.personalizeMeeting,
                    disableG2MM: self.disableG2MM(),
                    howToSchedule: self.howToSchedule
                }
            };
        });

        app.on('meeting:in-session').then(function (meeting) {
            self.meetingInSession(meeting.meetingId === self.gotomeetMeeting().meetingId);
        });

        app.on('gotomeet:profile').then(function (profile) {
            self.gotomeetProfile(profile);
        });

        app.on('gotomeet:newSubject').then(function (meeting) {
            self.gotomeetName(meeting.subject);
            self.gotomeetMeeting(meeting);
        });

        self.personalizeMeeting = function () {
            if (!self.isModalOpen()) {
                self.isModalOpen(true);
                mixpanelHelper.track('Open Personalize Meeting');
                personalizeMeeting.show()
                    .then(function () {
                        self.isModalOpen(false);
                    })
                    .fail(function () {
                        self.isModalOpen(false);
                    });
            }
        };

        // create recurring meeting and update gotomeet with new meeting
        self.createGotomeetMeeting = function () {
            return userApi.me()
                .then(function (me) {
                    var meetingSettings = {
                        meetingType: 'recurring',
                        subject: me.firstName + ' ' + me.lastName
                    };

                    return meetingsApi.create(meetingSettings)
                        .then(function (meeting) {
                            var profileInfo = {
                                userKey: me.key,
                                meetingId: meeting.meetingId
                            };

                            return g2mmApi.update(self.gotomeetProfile().profileId, profileInfo)
                                .done(function () {
                                    self.gotomeetMeeting(meeting);
                                });
                        });
                });
        };

        self.isBrowserHtml5Compatible = function () {
            return bowser.chrome && bowser.version > 33;
        };

        self.startMeeting = function () {
            var meeting = self.gotomeetMeeting();
            return startMeeting(meeting, {saMethod: 'starting_g2mm_meeting', isBrowserHtml5Compatible: self.isBrowserHtml5Compatible()});
        };

        self.endMeeting = function () {
            app.trigger('meeting:end', self.gotomeetMeeting().meetingId);
            router.navigate('');
        };

        self.showSessionInProgressBanner = function () {
            var banner = {
                id: 'session-in-progress',
                classes: 'alert-warning',
                iconClasses: 'togo-icon togo-icon-alert',
                title: i18n.t('myMeetings.sessionInProgress.header'),
                message: i18n.t('myMeetings.sessionInProgress.message'),
                removeOnNavigation: true
            };

            app.trigger('banner:add', banner);
        };

        self.scheduleMeeting = function () {
            popover.hide('#schedule-later', true);

            // todo: check if meetings exist
            if (!self.isModalOpen()) {
                self.isModalOpen(true);
                window.mixpanel.track('Open Schedule Meeting');

                userApi.settings().then(function (settings) {
                    var isRoom = settings.hasOwnProperty('roomsEnabled') &&
                        settings.roomsProvisioned &&
                        settings.roomsEnabled;
                    Scheduler.show(null, isRoom)
                        .then(function () {
                            self.isModalOpen(false);
                        })
                        .fail(function () {
                            self.isModalOpen(false);
                        });
                });
            }
        };

        self.showTrialEnding = function () {
            popover.hide('trial-ending-marvel-modal', true);
            // todo: check if meetings exist
            if (!self.isModalOpen()) {
                self.isModalOpen(true);
                mixpanelHelper.track('Open Trial Ending');

                var marvelModal = new MarvelMessage();
                marvelModal.show()
                .then(function () {
                    self.isModalOpen(false);
                })
                .fail(function () {
                    self.isModalOpen(false);
                });
            }
        };

        self.invitePeople = function () {
            if (!self.isModalOpen()) {
                self.isModalOpen(true);
                Invite.show(self.gotomeetMeeting().meetingId).then(function () {
                    self.isModalOpen(false);
                })
                .fail(function () {
                    self.isModalOpen(false);
                });
            }
        };

        self.compositionComplete = function () {
            invitePopover.show();
        };

        self.activate = function () {
            var meetingRequest = meetingsApi.forOrganizerFormatted();

            return $.when(
                g2mmApi.getByUserKey(),
                userApi.getServiceStatus()
                )
                .then(function (profileData, statusData) {
                    if (!statusData[0]['gotomeetme-service'].up) {
                        self.disableG2MM(true);
                    } else {
                        var profile = profileData[0];
                        self.gotomeetProfile(profile);

                        meetingRequest.then(function (meetings) {
                            _.forEach(meetings, function (meeting) {
                                if (meeting.screenSharing) {
                                    self.meetingInSession(meeting);
                                    app.trigger('gotomeet:meeting', meeting);
                                }

                                if (meeting.meetingId === self.gotomeetProfile().meetingId) {
                                    // check if has meeting name, if not assign one
                                    if (!meeting.subject) {
                                        meeting.subject = i18n.t('meeting.schedule.title.default.text');
                                    }

                                    // publish gotomeet.me meeting
                                    app.trigger('gotomeet:meeting', meeting);

                                    self.gotomeetName(meeting.subject);
                                    self.gotomeetMeeting(meeting);
                                }
                            });

                            if (!self.gotomeetMeeting()) {
                                self.createGotomeetMeeting();
                            }
                        });
                    }
                })
                .fail(function () {
                    return meetingsApi.forOrganizerFormatted().then(function (meetings) {
                        _.forEach(meetings, function (meeting) {
                            if (meeting.screenSharing) {
                                self.meetingInSession(meeting);
                            }
                        });
                    });
                })
                .always(function () {
                    if (window.location.hash && (window.location.hash.indexOf('#schedule') === 0)) {
                        self.scheduleMeeting();
                    }

                    if (window.location.hash && (window.location.hash.indexOf('#sessionInProgress') === 0)) {
                        self.showSessionInProgressBanner();
                    }

                    if (window.location.hash && (window.location.hash.indexOf('#trialEnding') === 0)) {
                        self.showTrialEnding();
                    }
                });
        };
    }
    module.exports = actionCenter;
});


